import { Text } from '@pixi/react'
import { TextStyle } from 'pixi.js'
import { useBalance } from '../../domain/balance/hook/useBalance'
import { t } from '../../domain/language/languageUtil'

interface SessionWinLoseProps {
  x: number
  y: number
}

const textStyle = new TextStyle({
  fontFamily: 'Arial',
  fontSize: 24,
  fill: '#ffffff',
})
export const SessionWinLose = (props: SessionWinLoseProps) => {
  const { currency, sessionWinLose } = useBalance()
  return (
    <Text
      text={`${t('session_net_position')}: ${sessionWinLose} ${currency}`}
      x={props.x}
      y={props.y}
      style={textStyle}
      anchor={0.5}
    />
  )
}
